import React from 'react';

const ButtonBlack = ({className = "", ...props}) => {
    return (
        <button {...props} className={`text-white p-2 font-bold bg-ea_black hover:bg-gray-700 rounded-lg uppercase ${className}`}>
            {props.children}
        </button>
    );
};

export default ButtonBlack;